import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <g clipPath="url(#clip0_6007_4037)">
        <g filter="url(#filter0_d_6007_4037)">
          <path
            d="M8 8.38773V51.1528C8 53.2971 9.97313 55.0405 12.4 55.0405H47.6C50.0269 55.0405 52 53.2971 52 51.1528V8.38773C52 6.24341 50.0269 4.5 47.6 4.5H12.4C9.97313 4.5 8 6.24341 8 8.38773ZM41 12.2755H19C17.7831 12.2755 16.8 11.4068 16.8 10.3316C16.8 9.2564 17.7831 8.38773 19 8.38773H41C42.2169 8.38773 43.2 9.2564 43.2 10.3316C43.2 11.4068 42.2169 12.2755 41 12.2755Z"
            fill="#33373F"
          />
          <path
            d="M8.28 51.1528V8.38773C8.28 6.42961 10.0942 4.78 12.4 4.78H47.6C49.9058 4.78 51.72 6.42961 51.72 8.38773V51.1528C51.72 53.1109 49.9058 54.7605 47.6 54.7605H12.4C10.0942 54.7605 8.28 53.1109 8.28 51.1528ZM19 12.5555H41C42.3379 12.5555 43.48 11.593 43.48 10.3316C43.48 9.07019 42.3379 8.10773 41 8.10773H19C17.6621 8.10773 16.52 9.07019 16.52 10.3316C16.52 11.593 17.6621 12.5555 19 12.5555Z"
            stroke="#7E8187"
            strokeWidth="0.56"
          />
        </g>
        <mask
          id="mask0_6007_4037"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="4"
          width="44"
          height="52"
        >
          <path d="M8 4.5H52V55.0405H8V4.5Z" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6007_4037)">
          <path
            d="M-0.161267 35.3377L32.3541 19.5911L60.8408 34.2852L29.0269 52.0167L-0.161267 35.3377Z"
            stroke="#464A50"
            strokeWidth="0.2"
          />
        </g>
        <path
          d="M31.1388 26.7968C31.4221 26.6596 31.7534 26.6638 32.0331 26.808L46.1814 34.106C46.8904 34.4718 46.9067 35.4798 46.2098 35.8682L30.1966 44.7932C29.8906 44.9637 29.5177 44.9617 29.2136 44.7879L14.7023 36.4957C14.0038 36.0966 14.0385 35.0781 14.7626 34.7275L31.1388 26.7968Z"
          fill="#2A2D34"
        />
        <path
          d="M20.8282 27.8028C20.9111 27.8028 20.9917 27.8231 21.0632 27.8627L22.8031 28.823V33.2086C22.803 33.2853 22.8213 33.3609 22.8566 33.4291C22.8919 33.4974 22.9431 33.5562 23.0058 33.6006C23.0686 33.6451 23.1412 33.674 23.2175 33.6848C23.2938 33.6956 23.3716 33.688 23.4444 33.6628L24.1595 33.4165C24.2582 33.3826 24.3683 33.4165 24.4318 33.4989L25.5294 34.9608C25.59 35.0419 25.6748 35.1019 25.7716 35.1322C25.8685 35.1626 25.9725 35.1617 26.0688 35.1298C26.1651 35.0979 26.2489 35.0365 26.3081 34.9545C26.3674 34.8724 26.3991 34.7738 26.3988 34.6727V30.8079L28.8277 32.1489C29.5564 32.5511 30.4417 32.5511 31.1692 32.1489L38.9349 27.8627C39.0084 27.8219 39.0913 27.8009 39.1754 27.8019C39.2596 27.8029 39.342 27.8258 39.4145 27.8682C39.487 27.9107 39.5471 27.9714 39.5888 28.0441C39.6305 28.1169 39.6524 28.1992 39.6522 28.2829V33.2515C39.6522 34.1305 39.1698 34.9394 38.3935 35.3596L31.1545 39.2888C30.4337 39.6786 29.5643 39.6786 28.8436 39.2888L21.6046 35.3596C21.2238 35.1532 20.906 34.8485 20.6845 34.4775C20.463 34.1066 20.3461 33.6831 20.3459 33.2515V28.2829C20.3459 28.0175 20.5615 27.8028 20.8282 27.8028ZM31.1567 17.2804L42.1095 23.2296C42.2236 23.2917 42.3189 23.3831 42.3853 23.4945C42.4516 23.6058 42.4866 23.7328 42.4866 23.8623C42.4866 23.9917 42.4516 24.1188 42.3853 24.2301C42.3189 24.3414 42.2236 24.4329 42.1095 24.4949L31.1567 30.4441C30.802 30.637 30.4043 30.738 30.0002 30.738C29.596 30.738 29.1983 30.637 28.8436 30.4441L17.8908 24.4949C17.7767 24.4329 17.6814 24.3414 17.6151 24.2301C17.5487 24.1188 17.5137 23.9917 17.5137 23.8623C17.5137 23.7328 17.5487 23.6058 17.6151 23.4945C17.6814 23.3831 17.7767 23.2917 17.8908 23.2296L28.8436 17.2804C29.1983 17.0876 29.596 16.9866 30.0002 16.9866C30.4043 16.9866 30.802 17.0876 31.1567 17.2804Z"
          fill="#6D7380"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6007_4037"
          x="3"
          y="1.5"
          width="54"
          height="60.5405"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6007_4037"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6007_4037"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6007_4037">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
